import React from 'react';
import Seal from '../assets/print/seal_corporate.png';
import Seal2 from '../assets/print/seal_general.png';
import Logo from '../assets/print/logo_corporate.png';
import Logo2 from '../assets/print/logo_general.png';
import moment from 'moment';
import { Get as GetConfig } from '../view/basic/http';

import ImgConfirm from '../assets/images/print_confirm.png';

const day = ['일', '월', '화', '수', '목', '금', '토'];

class Bill extends React.Component {
    render() {
        const { data } = this.props;

        return (
            <div className="print_content">
                <div className="content">
                    <div className="table_list">
                        <table className="tbl_board_report">
                            <colgroup>
                                <col width="200" />
                                <col width="200" />
                                <col width="200" />
                                <col width="200" />
                                <col width="200" />
                                <col width="200" />
                                <col width="200" />
                            </colgroup>
                            <tr>
                                <td colSpan={5} style={{ fontSize: 30, fontWeight: 'bold' }}>
                                    분동운반인력 안전관리 교육일지
                                </td>
                                <td style={{ fontSize: 14, fontWeight: 'bold' }}>매달 10일 제출</td>
                            </tr>
                            <tr>
                                <td>교육주관</td>
                                <td>한국분동 주식회사</td>
                                <td>교육담당</td>
                                <td>
                                    최지원
                                    <img src={ImgConfirm} style={{ width: 30, height: 30, marginLeft: 6 }} />
                                </td>
                                <td>교육일자</td>
                                <td>{moment(data.report.createdAt).format('YYYY-MM-DD')}</td>
                            </tr>
                            <tr>
                                <td colSpan={4} style={{ fontSize: 26, fontWeight: 'bold' }}>
                                    업 무 수 행 교 육 내 용
                                </td>
                                <td>확인 (읽음)</td>
                                <td>교육대상자확인</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    승강기설치 검사현장 내에서는 반드시 안전모, 안전화, 각반 착용한다.
                                </td>
                                <td>O</td>
                                <td>배차지역</td>
                            </tr>

                            <tr>
                                <td colSpan={4} className="content_left">
                                    운행전 분동운반 차량의 리프트 장치(로프파단, 유압누수)확인.
                                </td>
                                <td>O</td>
                                <td rowSpan={5}>{data.branch.title}</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    분동운반대차 바퀴의 베어링에 오일 및 방청유 도포할 것.
                                </td>
                                <td>O</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    분동운반대차 상, 하차시 바퀴 고정용 고임 장치후 작동할 것.
                                </td>
                                <td>O</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    승강기 내부에 분동 및 대차 적재시 하중을 골고루 분산 시킬 것.
                                </td>
                                <td>O</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    승강기 내부 판넬의 찍힘, 긁힘에 주의할 것.
                                </td>
                                <td>O</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    100% 오바로드 셋팅시 피트 내 작업자와만 대화할 것.
                                </td>
                                <td>O</td>
                                <td>성명</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    검사원과 분동적재등 의사소통시 복명복창 할 것.
                                </td>
                                <td>O</td>
                                <td rowSpan={3}>{data.name}</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    승강기 내부 조작반을 이용하여 승강기 도어를 개폐할 것.
                                </td>
                                <td>O</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    정밀검사시 분동적재 무게에 의한 카의 빠짐, 처짐에 주의.
                                </td>
                                <td>O</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    분동운반 대차 내에 절대로 손가락 넣지 말 것.
                                </td>
                                <td>O</td>
                                <td>확인(사인)</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    건물 내부 및 바닥의 대리석 파손에 주의 할 것.
                                </td>
                                <td>O</td>
                                <td rowSpan={3}>
                                    {/* <img src={data.report.sign} style={{ width: 100, height: 50 }} /> */}
                                    <img
                                        src={(data.report.sign || '').replace('http://kw24.co.kr:3000', 'https://api.kw24.co.kr')}
                                        style={{ width: 100, height: 50 }}
                                        />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    분동적재시 안전된 자세를 취하며 분동을 놓거나 떨어뜨리지 않도록 주의할 것.
                                </td>
                                <td>O</td>
                            </tr>
                            <tr>
                                <td className="content_left">교육목적</td>
                                <td colSpan={4} className="content_left">
                                    분동운반 작업자에 대한 안전교육을 통하여 분동운반 업무시 발생할 수 있는 안전사고를 방지하기 위함.
                                </td>
                            </tr>
                        </table>
                        {/* <div style={{ fontSize: 20, fontWeight: 'bold', textAlign: 'right', marginTop: 10 }}>사단법인 대한승강기 협회 귀중</div> */}
                    </div>
                </div>
            </div>
        );
    }
}

export default Bill;
